export const defaultScoreType = 'basic_scale';
